"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuadTreeEventTargetProvider = void 0;
const quad_event_target_provider_1 = require("./quad-event-target-provider");
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Incrementally updatable entity quad tree target provider. The yield time can be configured by setting {@link IQuadTreeTargetOptions.yieldTime}.
 */
class QuadTreeEventTargetProvider {
    constructor(entityTree, plot, interactiveGroups, options) {
        this.entityTree = entityTree;
        this.plot = plot;
        this.interactiveGroups = interactiveGroups;
        this.options = options;
        this.dragTargetProvider = new quad_event_target_provider_1.QuadEventTargetProvider(this.interactiveGroups.draggable, this.entityTree);
        this.clickTargetProvider = new quad_event_target_provider_1.QuadEventTargetProvider(this.interactiveGroups.clickable, this.entityTree);
        this.hoverTargetProvider = new quad_event_target_provider_1.QuadEventTargetProvider(this.interactiveGroups.hoverable, this.entityTree);
    }
    *update(canvasDims, start) {
        const plotDimensions = this.plot.plotDimensionsOBL.cssArea.wholeRange;
        const range = rc_js_util_1._Math.max(plotDimensions.getXRange(), plotDimensions.getYRange());
        this.entityTree.sharedTree.setOptions(Math.ceil(Math.log2(range)), 4);
        this.entityTree.sharedTree.setTopLevel(plotDimensions);
        const entitiesByHitTester = this.interactiveGroups.hitTestable.getEntitiesByHitTester();
        const updateArg = this.interactiveGroups.hitTestable.argProvider.getUpdateArg(this.plot, canvasDims);
        this.entityTree.setHitTestArg(updateArg);
        const quadTree = this.entityTree;
        const yieldTime = this.options.yieldTime;
        for (let i = 0, iEnd = entitiesByHitTester.length; i < iEnd; ++i) {
            const hitTestComponent = entitiesByHitTester[i][0];
            const entities = entitiesByHitTester[i][1];
            for (let j = 0, jEnd = entities.length; j < jEnd; ++j) {
                if (performance.now() - start > yieldTime) {
                    yield;
                    start = performance.now();
                }
                const entity = entities[j];
                if (entity.isFiltered) {
                    continue;
                }
                hitTestComponent.index(entity, updateArg, quadTree);
            }
        }
    }
}
exports.QuadTreeEventTargetProvider = QuadTreeEventTargetProvider;
//# sourceMappingURL=quad-tree-event-target-provider.js.map